import { supabase } from '../lib/supabase';

class TokenManager {
  private static instance: TokenManager;
  private refreshPromise: Promise<string | null> | null = null;
  private tokenExpiryTime: number | null = null;
  
  private constructor() {}
  
  static getInstance() {
    if (!this.instance) {
      this.instance = new TokenManager();
    }
    return this.instance;
  }

  // Get token with automatic refresh if needed
  async getValidToken(): Promise<string | null> {
    const session = await supabase.auth.getSession();
    const token = session.data.session?.access_token;
    
    if (!token) return null;
    
    // Check if token needs refresh (5 minutes before expiry)
    if (this.shouldRefreshToken()) {
      return this.refreshToken();
    }
    
    return token;
  }

  private shouldRefreshToken(): boolean {
    if (!this.tokenExpiryTime) return true;
    // Refresh if less than 5 minutes until expiry
    return Date.now() > this.tokenExpiryTime - 5 * 60 * 1000;
  }

  private async refreshToken(): Promise<string | null> {
    // If already refreshing, return existing promise
    if (this.refreshPromise) {
      return this.refreshPromise;
    }

    this.refreshPromise = new Promise(async (resolve) => {
      try {
        const { data } = await supabase.auth.refreshSession();
        const token = data.session?.access_token;
        
        if (token) {
          // Set expiry time (default Supabase tokens last 1 hour)
          this.tokenExpiryTime = Date.now() + 60 * 60 * 1000;
        }
        
        resolve(token || null);
      } catch (error) {
        console.error('Token refresh failed:', error);
        resolve(null);
      } finally {
        this.refreshPromise = null;
      }
    });

    return this.refreshPromise;
  }
}

export const tokenManager = TokenManager.getInstance(); 